import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const putAlertObsoletereadCountSlice = createApi(`PutAlertObsoletereadCountSlice`,"PUT");

const PutAlertObsoletereadCountSlice = createSlice({
  name: 'PutAlertObsoletereadCountSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putAlertObsoletereadCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putAlertObsoletereadCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putAlertObsoletereadCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PutAlertObsoletereadCountSlice.reducer;